import Schema from 'AppReact/schema';
import { fullInspection } from '../../apps/admin/inspections/types';

export default {
  inspection: Schema(fullInspection, 'object', { defaultValue: {} }),
  isOpen: Schema('boolean', 'primitive', { defaultValue: false }),
  hideCosts: Schema('boolean', 'primitive', { defaultValue: false }),
  messageIndex: Schema('integer', 'primitive', { defaultValue: 0 })
}